import services from './../../services/service'; // Service Class
import Preset from './../../mixins/preset.js'

let service = new services();

export default {

  name: "SecondHeader",
  mixins: [Preset],
  data() {
      return {
        //   user: {}, 
          user_slug: {}
      }
  },
  methods: {
    // getUser() {
    //     let u = localStorage.getItem("cityneeds_user");
    //     if(u != null) {
    //         //let user = JSON.parse(u);
    //         //let fullname = user.user_fullname;
    //         this.user = u;
    //         this.user_slug = u.replace(" ", "_");
    //     }else{
    //         this.user = null;
    //     }
    // }
  },
  created: function() {
    //   this.getUser();
  }
}


// WEBPACK FOOTER //
// ./src/components/Second-Header/script.js